module.exports = __webpack_public_path__ + "img/chilim-spark.b0beab8d.png";